// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationInstallmentsPath = 'M98 51H49V2h3.5C77.629 2 98 22.371 98 47.5V51zm-12.183-7H90.8C89.135 25.514 74.486 10.865 56 9.2v4.983A33.5 33.5 0 0185.817 44zM59 44h-3v-9.1a5 5 0 100-9.8v-3.87a26.393 26.393 0 0113.862 6.249 5 5 0 106.063 7.619A26.32 26.32 0 0178.77 44H69a5 5 0 00-10 0zm-18.5 56C18.133 100 0 81.868 0 59.5 0 37.133 18.133 19 40.5 19H44v37h37v3.5c-.055 22.345-18.155 40.445-40.5 40.5zM37 26.2C21.071 27.864 8.786 40.487 7.163 56H37V26.2zm0 66.638C21.27 91.208 8.792 78.73 7.162 63H37v29.838zm7-.001C59.513 91.214 72.136 78.929 73.8 63H44v29.837z';
var IllustrationInstallments = baseIllustration('IllustrationInstallments', {
  getPath: () => IllustrationInstallmentsPath
}, 'ColoredIllustrationInstallments');

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationInstallments;
//# sourceMappingURL=index.js.map